import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { IVisualization } from "../Contracts";
import { VisualizationAxios } from "../Contracts/Axios";
import { IAction, IServiceResult, ITableauView } from "../Models/Models";

export enum TableauActionTypes {
  VIEWS_LOADED = "@@Tableau/VIEWS_LOADED",
  REQUEST_VIEWS = "@@Tableau/REQUEST_VIEWS",
}

export const viewsLoaded = (views: ITableauView[]): IAction<ITableauView[]> => {
    const action: IAction<ITableauView[]> = {
        type: TableauActionTypes.VIEWS_LOADED,
        payload: views,
    };

    return action;
};

export const requestViews = (): IAction<string> => {
    const action: IAction<string> = {
        type: TableauActionTypes.REQUEST_VIEWS,
        payload: null,
    };

    return action;
};

//Thunk Action
export const loadTableauViews: ActionCreator<ThunkAction<any, any, any, any>>
  = () => {
      return (dispatch: Dispatch<any>) => {
          dispatch(requestViews());

          const vizAjax: IVisualization = new VisualizationAxios();
          const promise = vizAjax.GetViews();
          promise
              .then((response: IServiceResult<ITableauView[]>): void => {
                  dispatch(viewsLoaded(response.data));
              })
              .catch((error: any) => {
                  //??
              });
      };
  };

export type TableauAction = IAction<ITableauView[]>;
